import request from "@/utils/request";

// 库存统计列表
export function scanningList(params) {
  return request({
    url: "/admin/scanning/lastList",
    method: "get",
    params,
  });
}

// 库存统计导出
export function scanningExportLastExcel(params) {
  return request({
    url: "/admin/scanning/exportLastExcel",
    method: "get",
    params,
    responseType: "blob",
  });
}

// 变动统计列表
export function recordList(params) {
  return request({
    url: "/admin/record/list",
    method: "get",
    params,
  });
}

// 变动统计导出
export function recordExportExcel(params) {
  return request({
    url: "/admin/record/exportExcel",
    method: "get",
    params,
    responseType: "blob",
  });
}

// 数据获取
export function scanningdata(params) {
  return request({
    url: "/admin/scanning/data",
    method: "get",
    params,
  });
}

// 扫描详情
export function scanningview(params) {
  return request({
    url: "/admin/scanning/view",
    method: "get",
    params,
  });
}

// 历史数据获取
export function historydata(params) {
  return request({
    url: "/admin/scanning/history/data",
    method: "get",
    params,
  });
}

//根据id获取点云数据
export function getRecordData(params){
  return request({
    url: "/admin/scanning/getRecordData",
    method: "get",
    params,
  });
}

export function historyinfo(params) {
  return request({
    url: "/admin/scanning/history/info",
    method: "get",
    params,
  });
}

//最新扫描记录
export function lastData(params) {
  return request({
    url: "/admin/scanning/lastData",
    method: "get",
    params,
  });
}

// 新增跨域接口
export function getHistoryDataCross(params) {
  return request({
    url: "/wx/historyData",
    method: "get",
    headers: {
      'token': params.token
    },
    params
  });
}

export function getLastDataCross(params) {
  return request({
    url: "/wx/lastData", 
    method: "get",
    headers: {
      'token': params.token
    },
    params
  });
}


// 历史数据获取
export function historyfile(params) {
  return request({
    url: "/admin/scanning/data/show",
    method: "get",
    params,
  });
}

// iframe历史记录
export function datanow(params) {
  return request({
    url: "/admin/scanning/data/now",
    method: "get",
    params,
  });
}

// 雷达配置读取
export function configload(params) {
  return request({
    url: "/admin/scanning/config/load",
    method: "get",
    params,
  });
}

// 读取IP
export function loadip(params) {
  return request({
    url: "/admin/scanning/device/config/load",
    method: "get",
    params,
  });
}

// 修改IP
export function saveip(params) {
  return request({
    url: "/admin/scanning/device/config/save",
    method: "get",
    params,
  });
}

// 雷达配置保存
export function configsave(data) {
  return request({
    url: "/admin/scanning/config/save",
    method: "post",
    data,
  });
}

//下载三维文件
export function scanningdownload(params) {
  return request({
    url: "/admin/scanning/download",
    method: "get",
    params,
  });
}

// 仓库最近数量详情
export function scanninginfo(params) {
  return request({
    url: "/admin/scanning/info",
    method: "get",
    params,
  });
}

//数量检测列表
export function scanninglist(params) {
  return request({
    url: "/admin/scanning/list",
    method: "get",
    params,
  });
}
export function exportExcel(params) {
  return request({
    url: "/admin/scanning/exportExcel",
    method: "get",
    params,
  });
}

//报警记录
export function warninglist(params) {
  return request({
    url: "/admin/warn/page",
    method: "get",
    params,
  });
}

//报警提醒
export function warningTip(params) {
  return request({
    url: "/admin/warn/getCurrWarnList",
    method: "get",
    params,
  });
}

// 获取扫描进度
export function scanningprogress(params) {
  return request({
    url: "/admin/scanning/progress",
    method: "get",
    params,
  });
}

// 开始扫描
export function scanningstart(params) {
  return request({
    url: "/admin/scanning/start",
    method: "get",
    params,
  });
}

// 停止扫描
export function scanningstop(params) {
  return request({
    url: "/admin/scanning/stop",
    method: "get",
    params,
  });
}

// 设备状态
export function scanningstate(params) {
  return request({
    url: "/admin/scanning/state",
    method: "get",
    params,
  });
}

// 删除记录
export function scanningdel(params) {
  return request({
    url: "/admin/scanning/del",
    method: "delete",
    params,
  });
}

// 吹扫
export function scanningclear(params) {
  return request({
    url: "/admin/scanning/clear",
    method: "get",
    params,
  });
}

// 设备重启
export function scanningrestart(params) {
  return request({
    url: "/admin/scanning/restart",
    method: "get",
    params,
  });
}

//门磁布防控制

export function mcbf(params) {
  return request({
    url: "/admin/scanning/mcbf",
    method: "get",
    params,
  });
}


//红外布防控制

export function hwbf(params) {
  return request({
    url: "/admin/scanning/hwbf",
    method: "get",
    params,
  });
}


//报警解除控制
export function alarmClear(params) {
  return request({
    url: "/admin/scanning/alarmClear",
    method: "get",
    params,
  });
}


// 删除报警记录
export function warningdel(params) {
  return request({
    url: "/admin/warn/delete",
    method: "delete",
    params,
  });
}

// 报警记录导出
export function exportWarnExcel(params) {
  return request({
    url: "/admin/warn/exportExcel",
    method: "get",
    params,
  });
}


//设备搜索
export function searchIpDevices(params) {
  return request({
    url: "/admin/scanning/searchIpDevices",
    method: "get",
    params,
  });
}

//获取最新点位
export function getLastData(params) {
  return request({
    url: "/admin/scanning/getLastData",
    method: "get",
    params,
  });
}

//读取设备参数
export function getDeviceParam(params) {
  return request({
    url: "/admin/scanning/getDeviceParam",
    method: "get",
    params,
  });
}

//保存设备参数
export function saveDeviceParam(data) {
  return request({
    url: "/admin/scanning/saveDeviceParam",
    method: "post",
    // headers: {
    //   isToken: false,
    // },
    data,
  });
}

//角度校准
export function saveAngle(data) {
  return request({
    url: "/admin/scanning/saveAngle",
    method: "post",
    data,
  });
}





//////////////////////////////////////////////////////
//单点料位
//仓库扫描列表
export function scanninglistSingle(params) {
  return request({
    url: "/admin/house/single/listHistoryData",
    method: "get",
    params,
  });
}

//温湿度扫描列表listSensorData
export function listSensorData(params) {
  return request({
    url: "/admin/house/single/listSensorData",
    method: "get",
    params,
  });
}

//最新扫描记录
export function getSingleData(params) {
  return request({
    url: "/admin/house/single/getSingleData",
    method: "get",
    params,
  });
}


//离线，最新一条记录getLastSingleData
export function getLastSingleData(params) {
  return request({
    url: "/admin/house/single/getLastSingleData",
    method: "get",
    params,
  });
}

//导出报表
export function exportExcelSingle(params) {
  return request({
    url: "/admin/house/single/exportExcel",
    method: "get",
    params,
  });
}


//测量
export function measureSingle(params) {
  return request({
    url: "/admin/house/single/rang",
    method: "post",
    params,
  });
}

//测量温湿度
export function measureSensor(params) {
  return request({
    url: "/admin/house/single/getSensorData",
    method: "post",
    params,
  });
}

//除尘

export function dustSingle(params) {
  return request({
    url: "/admin/house/single/dust",
    method: "post",
    params,
  });
}


// 删除记录
export function historyDel(params) {
  return request({
    url: "/admin/house/single/historyDel",
    method: "delete",
    params,
  });
}


//线缆历史数据
export function historyCable(params) {
  return request({
    url: "/sensor/list",
    method: "get",
    params,
  });
}

//根据ckbh获取传感器列表
export function getSensorList(params) {
  return request({
    url: "/sensor/getSensorList",
    method: "get",
    params,
  });
}

//根据传感器名称获取传感器数据
export function getSensorDataList(params) {
  return request({
    url: "/sensor/getSensorDataList",
    method: "get",
    params,
  });
}

//导出传感器数据报表按钮
export function exportSensorData(params) {
  return request({
    url: "/sensor/exportExcel",
    method: "get",
    params,
  });
}

//查看历史记录详细数据
export function getSensorLast(params) {
  return request({
    url: "/sensor/get",
    method: "get",
    params,
  });
}

//根据仓库编号获取详细数据

export function getSensorLastByCkbh(params) {
  return request({
    url: "/sensor/getByCkhb",
    method: "get",
    params,
  });
}

//测量线缆
export function generateData(params) {
  return request({
    url: "/sensor/generateData",
    method: "post",
    params,
  });
}


/////////////////////////////////////////////////////////////////////////////

// 多点料位

// 扫描记录列表（多点）
export function scanninglistMulti(params) {
  return request({
    url: "/admin/lnBarnAreaNum/page",
    method: "get",
    params,
  });
}

// 删除扫描记录（多点）
export function scanningdelMulti(params) {
  return request({
    url: "/admin/lnBarnAreaNum/del",
    method: "delete",
    params,
  });
}

// 扫描记录详情（多点）
export function scanningDetailMulti(params) {
  return request({
    url: "/admin/lnBarnAreaNum/detail",
    method: "get",
    params,
  });
}

// 最近一周扫描重量统计（多点）
export function scanningWeekCountMulti(params) {
  return request({
    url: "/admin/lnBarnAreaNum/weekCount",
    method: "get",
    params,
  });
}